module.exports = __webpack_public_path__ + "static/img/printkup1.c0775c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/printkup1.png
// module id = Wgnl
// module chunks = 0